/**
 * Reference to storage object
 */
const storage: Storage = sessionStorage;

/**
 * get serialized object stored in the local storage
 * @param key key to get item for
 */
export function getStorage<T extends Record<string, unknown>>(key: string) {
  const current = storage.getItem(key);
  return JSON.parse(current || '{}') as T;
}

/**
 * update storage data with given key and object of value
 * @param key key to serialize storage on
 * @param value value to overwrite previous item inside the store
 */
export function updateStorage<T extends Record<string, unknown>>(key: string, value: T) {
  const prevState = getStorage<T>(key);
  const newStorage: T = {
    ...prevState,
    ...value
  };
  storage.setItem(key, JSON.stringify(newStorage));
}

/**
 * remove an item from the storage
 * @param key key to remove
 */
export function deleteItem(key: string) {
  storage.removeItem(key);
}

/**
 * clear the storage from all items
 */
export function clear() {
  storage.clear();
}
